import { createFileRoute, redirect } from '@tanstack/react-router'

import { ProgramLayout, programLinkOptions } from '~/features/dashboard/components/layout';

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$program',
)({
  beforeLoad: async ({ params }) => {
    const { program } = params;
    if (program !== "weight-loss" && program !== "urgent-care") {
      throw redirect(programLinkOptions("weight-loss"))
    }
  },
  component: ProgramLayout,
})


